import ProfileLayout from "../../layouts/Profile.layout";
import {
  InvoiceDetailsForm,
  VerifyForm,
} from "../../components/forms/settings";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../store/reducers/user";
import { AccountType } from "../../types/UserTypes";
import { useVerifyForm } from "../../hooks/useVerifyForm";

export const InvoiceDetails = () => {
  const { account_type, invoicing_data } = useSelector(selectCurrentUser);

  const title =
    account_type === AccountType.CONTRACTOR ? "Invoice details" : "Company";

  const showVerifyForm = useVerifyForm(account_type === AccountType.BUSINESS);

  return (
    <ProfileLayout>
      <div className="md:mr-3">
        <h1 className="hidden md:block theme-heading text-center mb-8">
          {title}
        </h1>

        <div className="hidden md:block theme-subheading text-center mb-16">
          The details are applied to every invoice you create
        </div>

        {showVerifyForm && (
          <VerifyForm className="mb-12" orientation="horizontal" />
        )}

        <div className="w-full flex flex-col items-stretch">
          <InvoiceDetailsForm data={invoicing_data} />
        </div>
      </div>
    </ProfileLayout>
  );
};
